import React, { useEffect, useState } from "react";
import { useAnalytics } from "@piiqtechnologies/ui-lib";
import { CardLayout } from "../CustomSubtopicCardLayout";
import { CommonRow } from "./CommonRow";
export const CommonCard = ({ title, subtitle, tooltip, initialSubtopics, baseCount, canAddMore, maxSubtopics, onAddedCountChange, onSubtopicsChange, saveTrigger, onEditingCountChange, readOnly, hasBeenRun, }) => {
    const analytics = useAnalytics();
    const defaultCount = baseCount !== null && baseCount !== void 0 ? baseCount : initialSubtopics.length;
    const [subtopics, setSubtopics] = useState(initialSubtopics);
    const [editingNewIndex, setEditingNewIndex] = useState(null);
    const addedCount = subtopics.length - defaultCount;
    useEffect(() => {
        onAddedCountChange === null || onAddedCountChange === void 0 ? void 0 : onAddedCountChange(addedCount);
    }, [addedCount, onAddedCountChange]);
    useEffect(() => {
        onSubtopicsChange === null || onSubtopicsChange === void 0 ? void 0 : onSubtopicsChange(subtopics);
    }, [subtopics, onSubtopicsChange]);
    const handleEdit = (index, newValue) => {
        const isDefault = index < defaultCount;
        if (!newValue && !isDefault) {
            analytics.track("Custom Subtopics | Subtopic Removed", { category: title, index });
            setSubtopics((prev) => prev.filter((_, i) => i !== index));
            return;
        }
        if (!newValue && isDefault) {
            return;
        }
        analytics.track("Custom Subtopics | Subtopic Edited", { category: title, index, newValue });
        setSubtopics((prev) => prev.map((item, i) => (i === index ? newValue : item)));
    };
    const handleDelete = (index) => {
        analytics.track("Custom Subtopics | Subtopic Deleted", { category: title, index });
        setSubtopics((prev) => prev.filter((_, i) => i !== index));
    };
    const handleAddSubtopic = () => {
        analytics.track("Custom Subtopics | Add Subtopic Clicked", { category: title });
        setSubtopics((prev) => [...prev, ""]);
        setEditingNewIndex(subtopics.length);
    };
    return (React.createElement(CardLayout, { title: title, subtitle: subtitle, tooltip: tooltip, canAddMore: canAddMore, maxSubtopics: maxSubtopics, onAddSubtopic: handleAddSubtopic, readOnly: readOnly, hasBeenRun: hasBeenRun },
        React.createElement(CommonRow, { subtopics: subtopics, defaultCount: defaultCount, onEdit: handleEdit, onDelete: handleDelete, editingNewIndex: editingNewIndex, onEditingNewHandled: () => setEditingNewIndex(null), category: title, saveTrigger: saveTrigger, onEditingCountChange: onEditingCountChange, readOnly: readOnly, hasBeenRun: hasBeenRun })));
};
